import React__default from 'react';

let Sizes = /*#__PURE__*/function (Sizes) {
  Sizes["sm"] = "sm";
  Sizes["md"] = "md";
  Sizes["lg"] = "lg";
  return Sizes;
}({});
const StepSizeContext = /*#__PURE__*/React__default.createContext({
  size: Sizes.md
});
const useStepSizeContext = () => React__default.useContext(StepSizeContext);
const StepSizeProvider = ({
  children
}) => {
  const [size, setSize] = React__default.useState(Sizes.md);
  return /*#__PURE__*/React__default.createElement(StepSizeContext.Provider, {
    value: {
      size,
      setSize
    }
  }, children);
};
StepSizeProvider.displayName = "StepSizeProvider";

export { Sizes, StepSizeProvider, useStepSizeContext };
